import { render, staticRenderFns } from "./details.vue?vue&type=template&id=5079d8e0&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&lang=css&"
import style1 from "./details.vue?vue&type=style&index=1&id=5079d8e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5079d8e0",
  null
  
)

export default component.exports